"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NolimitPromotionPlugin = void 0;
/**
 * Created by Jonas Wålekvist on 2019-12-05.
 */
const NolimitApplication_1 = require("@nolimitcity/slot-launcher/bin/NolimitApplication");
const NolimitLauncher_1 = require("@nolimitcity/slot-launcher/bin/NolimitLauncher");
const ApiPlugin_1 = require("@nolimitcity/slot-launcher/bin/plugins/ApiPlugin");
const PromoPanelAssetConfig_1 = require("./config/PromoPanelAssetConfig");
const APIEventSystem_1 = require("@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem");
const KeypadPlugin_1 = require("@nolimitcity/slot-launcher/bin/plugins/KeypadPlugin");
const PromoPanelEvents_1 = require("./events/PromoPanelEvents");
const PromoPanelButtonIDs_1 = require("./enums/PromoPanelButtonIDs");
const PromoPanelConfig_1 = require("./config/PromoPanelConfig");
const FontLoader_1 = require("@nolimitcity/slot-launcher/bin/loader/FontLoader");
const SoundPlugin_1 = require("@nolimitcity/slot-launcher/bin/plugins/SoundPlugin");
const OpenSans_1 = require("@nolimitcity/slot-launcher/bin/loader/font/OpenSans");
const ImgLoader_1 = require("@nolimitcity/slot-launcher/bin/loader/ImgLoader");
const TemplateLoader_1 = require("@nolimitcity/slot-launcher/bin/loader/TemplateLoader");
const IntroPageCreator_1 = require("./intro/IntroPageCreator");
const ActionSpinsController_1 = require("./feature/actionspins/ActionSpinsController");
const ASInterfaces_1 = require("./interfaces/ASInterfaces");
const ASEnums_1 = require("./enums/ASEnums");
const NolimitPromoMainView_1 = require("./NolimitPromoMainView");
const NolimitWinnersController_1 = require("./feature/winners/NolimitWinnersController");
const ResponseParser_1 = require("./utils/ResponseParser");
const VoucherController_1 = require("./feature/voucher/VoucherController");
class NolimitPromotionPlugin {
    get newView() {
        return this._newView;
    }
    constructor(config) {
        this.name = "PromoPanel";
        this._featureControllerMap = new Map();
        this.lastOpenFeature = "";
        if (config) {
            NolimitPromotionPlugin.promoPanelGameConfiguration = config;
            NolimitPromotionPlugin.ASOptionsData = config.getActionSpinOptions && config.getActionSpinOptions();
        }
    }
    static fetchPlugins() {
        for (let plugin of NolimitLauncher_1.NolimitLauncher.plugins) {
            if ((0, SoundPlugin_1.isSoundPlugin)(plugin)) {
                NolimitPromotionPlugin.sound = plugin;
            }
            else if ((0, KeypadPlugin_1.isKeypadPlugin)(plugin)) {
                NolimitPromotionPlugin.keypadPlugin = plugin;
            }
            else if ((0, ApiPlugin_1.isApiPlugin)(plugin)) {
                NolimitPromotionPlugin.apiPlugIn = plugin;
            }
        }
        if (NolimitPromotionPlugin.sound == undefined) {
            return Promise.reject(new Error("NolimitPromotionPlugin is missing SoundPlugin"));
        }
        if (NolimitPromotionPlugin.apiPlugIn == undefined) {
            return Promise.reject(new Error("NolimitPromotionPlugin is missing ApiPlugin"));
        }
        if (NolimitPromotionPlugin.keypadPlugin == undefined) {
            return Promise.reject(new Error("NolimitPromotionPlugin is missing KeypadPlugin"));
        }
        return Promise.resolve();
    }
    static saveToLocalStorage(key, value) {
        NolimitPromotionPlugin.apiPlugIn.settings.set(key, value);
    }
    static getFromLocalStorage(key, defaultValue) {
        return NolimitPromotionPlugin.apiPlugIn.settings.get(key, defaultValue);
    }
    // ---- NolimitPlugin interface implementation
    init() {
        return new Promise((resolve) => {
            NolimitPromotionPlugin.fetchPlugins().catch((reason) => {
                return Promise.reject(reason);
            });
            this.loadResourcePromise = this.loadGameResources();
            resolve(this);
        });
    }
    addAssetsToLoader(loader, assets) {
        for (let asset of assets) {
            loader.add(asset.name, asset.url);
        }
    }
    getReady() {
        if (!this.hasPromotions()) {
            return Promise.resolve(this);
        }
        const fontLoader = new FontLoader_1.FontLoader(NolimitApplication_1.NolimitApplication.resourcePath);
        fontLoader.add(OpenSans_1.OpenSans.NORMAL_300);
        fontLoader.add(OpenSans_1.OpenSans.NORMAL_400);
        fontLoader.add(OpenSans_1.OpenSans.ITALIC_600);
        fontLoader.add(OpenSans_1.OpenSans.NORMAL_600);
        fontLoader.add(OpenSans_1.OpenSans.NORMAL_700);
        fontLoader.add(OpenSans_1.OpenSans.NORMAL_800);
        fontLoader.add(OpenSans_1.OpenSans.ITALIC_800);
        NolimitPromotionPlugin.imgLoader = new ImgLoader_1.ImgLoader(NolimitApplication_1.NolimitApplication.resourcePath);
        this.addAssetsToLoader(NolimitPromotionPlugin.imgLoader, PromoPanelAssetConfig_1.PromoPanelAssetConfig.getNavigationAssets());
        if (this.hasNolimitVoucher()) {
            this.addAssetsToLoader(NolimitPromotionPlugin.imgLoader, PromoPanelAssetConfig_1.PromoPanelAssetConfig.getVoucherAssets());
        }
        if (this.hasActionSpin()) {
            this.addAssetsToLoader(NolimitPromotionPlugin.imgLoader, PromoPanelAssetConfig_1.PromoPanelAssetConfig.getActionSpinsAssets());
            this.addAssetsToLoader(NolimitPromotionPlugin.imgLoader, PromoPanelAssetConfig_1.PromoPanelAssetConfig.getActionSpinsGameFeedAssets());
        }
        if (this.hasNolimitWinners()) {
            this.addAssetsToLoader(NolimitPromotionPlugin.imgLoader, PromoPanelAssetConfig_1.PromoPanelAssetConfig.getNolimitWinnersAssets());
        }
        const promise = Promise.all([NolimitPromotionPlugin.imgLoader.load(), fontLoader.load()]);
        return promise.then(value => {
            return Promise.resolve(this);
        });
    }
    /**
     * To load game feature assets( from nolimit/promopanel folder at game side).
     */
    getReadyToStart() {
        if (!this.hasPromotions()) {
            return Promise.resolve(this);
        }
        return this.loadResourcePromise.then(() => {
            //lastOpenFeature is used here to set the "default" page to open. The last one to be set will be the default.
            if (this.hasNolimitWinners()) {
                this.lastOpenFeature = PromoPanelButtonIDs_1.PromoPanelButtonIDs.NOLIMIT_WINNERS;
                this._featureControllerMap.set(PromoPanelButtonIDs_1.PromoPanelButtonIDs.NOLIMIT_WINNERS, new NolimitWinnersController_1.NolimitWinnersController(this, PromoPanelButtonIDs_1.PromoPanelButtonIDs.NOLIMIT_WINNERS));
            }
            if (this.hasNolimitVoucher()) {
                this.lastOpenFeature = PromoPanelButtonIDs_1.PromoPanelButtonIDs.VOUCHER;
                this._featureControllerMap.set(PromoPanelButtonIDs_1.PromoPanelButtonIDs.VOUCHER, new VoucherController_1.VoucherController(this, PromoPanelButtonIDs_1.PromoPanelButtonIDs.VOUCHER));
            }
            if (this.hasActionSpin()) {
                this.lastOpenFeature = PromoPanelButtonIDs_1.PromoPanelButtonIDs.ACTION_SPINS;
                this._featureControllerMap.set(PromoPanelButtonIDs_1.PromoPanelButtonIDs.ACTION_SPINS, new ActionSpinsController_1.ActionSpinsController(this, PromoPanelButtonIDs_1.PromoPanelButtonIDs.ACTION_SPINS));
            }
            this._newView = new NolimitPromoMainView_1.NolimitPromoMainView(this, this._featureControllerMap);
            return Promise.resolve(this);
        });
    }
    start() {
        return Promise.resolve(this);
    }
    /**
     * This function is called in the getReady phase. And here all init data
     */
    getKeypadGuide() {
        const templateLoader = new TemplateLoader_1.TemplateLoader(NolimitPromotionPlugin.apiPlugIn.resources.getStaticRoot());
        templateLoader.add({
            name: "gui-guide",
            url: "node_modules/@nolimitcity/promo-panel/resources/default/templates/gui-guide.mustache"
        });
        const data = {
            hasNolimitWinners: this.hasNolimitWinners(),
            hasActionSpin: this.hasActionSpin(),
            hasNolimitTournaments: this.hasNolimitTournaments(),
            hasNolimitVoucher: this.hasNolimitVoucher(),
            location: ".." + PromoPanelAssetConfig_1.PromoPanelAssetConfig.getGameResourcePath()
        };
        if (!this.hasPromotions()) {
            return Promise.resolve("");
        }
        return templateLoader.load().then((assets) => {
            for (let asset of assets) {
                if (asset.name == "gui-guide" && asset.loadedData) {
                    return NolimitPromotionPlugin.apiPlugIn.translations.render(asset.loadedData, data);
                }
            }
            throw new Error("NolimitPromotionPlugin could not load gui-guide");
        });
    }
    getIntroPages() {
        if (NolimitPromotionPlugin.apiPlugIn.isReplay) {
            return Promise.resolve([]);
        }
        const creator = new IntroPageCreator_1.IntroPageCreator();
        return this.loadResourcePromise.then(() => {
            return creator.getIntroPages(this);
        });
    }
    // ---- PromotionPlugin interface implementation
    open() {
        if (NolimitPromotionPlugin.apiPlugIn.promotionHandler.promotionData.size > 0) {
            if (this._featureControllerMap.has(PromoPanelButtonIDs_1.PromoPanelButtonIDs.VOUCHER)) {
                this.lastOpenFeature = PromoPanelButtonIDs_1.PromoPanelButtonIDs.VOUCHER;
            }
        }
        this.updateMenuInteraction();
        NolimitApplication_1.NolimitApplication.addDialog(this._newView, true);
        this._newView.open();
        this.openFeature(this.lastOpenFeature);
        NolimitPromotionPlugin.apiPlugIn.events.trigger(PromoPanelEvents_1.PromoPanelEvents.PROMO_PANEL_OPENED);
        ResponseParser_1.ResponseParser.setBoostAndGetCost(undefined, true);
        /*        this.setSavedSettings();
                NolimitPromotionPlugin.isFreeBet = NolimitPromotionPlugin.apiPlugIn.freeBets.hasFreeBets();
                this._view.open();
                this.buttonClick(new GuiButton(NolimitPromotionPlugin.getDefaultButtonConfig().id), true);
                */
    }
    updateMenuInteraction() {
        if (NolimitPromotionPlugin.apiPlugIn.promotionHandler.hasFreeBets()) {
            if (this._featureControllerMap.has(PromoPanelButtonIDs_1.PromoPanelButtonIDs.VOUCHER)) {
                this.lastOpenFeature = PromoPanelButtonIDs_1.PromoPanelButtonIDs.VOUCHER;
            }
            this._newView.enableInteraction(false);
            this._newView.enableInteraction(true, [PromoPanelButtonIDs_1.PromoPanelButtonIDs.VOUCHER]);
        }
        else {
            this._newView.enableInteraction(true);
        }
    }
    openFeature(id = this.lastOpenFeature) {
        this._featureControllerMap.forEach((controller, key) => {
            if (key == id) {
                this._newView.backgroundColor = controller.config.color;
                controller.open();
                this._newView.switchContent(controller.view);
                this.lastOpenFeature = key;
            }
            else {
                controller.close();
            }
        });
        this._newView.updateButtonState(this.lastOpenFeature);
    }
    startFreeBetsActionSpin(featureName = "") {
        this.openFeature(PromoPanelButtonIDs_1.PromoPanelButtonIDs.ACTION_SPINS);
        const controller = this._featureControllerMap.get(PromoPanelButtonIDs_1.PromoPanelButtonIDs.ACTION_SPINS);
        if (controller) {
            NolimitPromotionPlugin.apiPlugIn.betFeatureController.setActiveBetFeature(featureName);
            controller.startActionSpins(true);
        }
    }
    /**
     * To close promo panel view
     */
    close(isFeatureBuy = false, isFreeBetTriggered = false) {
        const controller = this._featureControllerMap.get(this.lastOpenFeature);
        if (controller) {
            controller.close();
        }
        if (NolimitApplication_1.NolimitApplication.hasOpenDialog && this._newView.parent != undefined) {
            NolimitApplication_1.NolimitApplication.removeDialog(this._newView, true);
            NolimitPromotionPlugin.apiPlugIn.events.trigger(PromoPanelEvents_1.PromoPanelEvents.PROMO_PANEL_CLOSED);
        }
        this._newView.clearContent();
    }
    /**
     * To minimize promo panel view
     */
    minimize() {
        NolimitPromotionPlugin.IS_MINIMIZED = true;
        NolimitApplication_1.NolimitApplication.minimizeDialog(this.newView);
        this.newView.visible = false;
        NolimitApplication_1.NolimitApplication.apiPlugin.events.trigger(APIEventSystem_1.APIEvent.ACTION_SPINS_IS_ACTIVE, false);
        NolimitApplication_1.NolimitApplication.apiPlugin.events.trigger(PromoPanelEvents_1.PromoPanelEvents.PROMO_PANEL_MINIMIZED);
    }
    /**
     * To maximize promo panel view
     */
    maximize() {
        this.newView.visible = true;
        NolimitApplication_1.NolimitApplication.addDialog(this.newView, true);
        NolimitPromotionPlugin.IS_MINIMIZED = false;
        NolimitApplication_1.NolimitApplication.apiPlugin.events.trigger(APIEventSystem_1.APIEvent.ACTION_SPINS_IS_ACTIVE, true);
        NolimitApplication_1.NolimitApplication.apiPlugin.events.trigger(PromoPanelEvents_1.PromoPanelEvents.PROMO_PANEL_MAXIMIZED);
    }
    /**
     * This is not safe to call in init phase. Things will be undefined.
     */
    hasPromotions() {
        const hasNolimitWinners = this.hasNolimitWinners();
        const hasNolimitTournaments = this.hasNolimitTournaments();
        const hasNolimitVoucher = this.hasNolimitVoucher();
        const hasNoLimitLightningSpins = this.hasActionSpin();
        const hasReplay = NolimitPromotionPlugin.apiPlugIn.options.replay;
        return (hasNolimitWinners || hasNolimitTournaments || hasNolimitVoucher || hasNoLimitLightningSpins) && !hasReplay;
    }
    hasNolimitWinners() {
        return (NolimitPromotionPlugin.apiPlugIn.gameClientConfiguration.nolimitWinnersEnabled);
    }
    hasActionSpin() {
        var _a;
        const value = !NolimitPromotionPlugin.apiPlugIn.options.funMode && NolimitPromotionPlugin.apiPlugIn.gameClientConfiguration.actionSpin && ((_a = NolimitPromotionPlugin.ASOptionsData) === null || _a === void 0 ? void 0 : _a.hasActionSpin);
        return value == true;
    }
    hasNolimitTournaments() {
        return false;
    }
    hasNolimitVoucher() {
        return NolimitPromotionPlugin.apiPlugIn.gameClientConfiguration.nolimitPromotionEnabled;
    }
    setSavedSettings() {
        NolimitPromotionPlugin.savedSettings = {
            asStopOnBonus: !!NolimitPromotionPlugin.apiPlugIn.settings.get(ASEnums_1.LocalStorageSettingsKey.AS_STOP_ON_BONUS),
            asBonusTabSelected: !!NolimitPromotionPlugin.apiPlugIn.settings.get(ASEnums_1.LocalStorageSettingsKey.AS_BONUS_TAB_SELECTED)
        };
    }
    /**
     * Loads game specific assets (they are needed for intro as well)
     */
    loadGameResources() {
        var _a, _b;
        const imgLoader = new ImgLoader_1.ImgLoader(NolimitApplication_1.NolimitApplication.resourcePath);
        this.addAssetsToLoader(imgLoader, PromoPanelAssetConfig_1.PromoPanelAssetConfig.getCommonAssets());
        if (NolimitPromotionPlugin.ASOptionsData) {
            let addedImages = [];
            let mainGameOptions = (0, ASInterfaces_1.parseOptionData)((_a = NolimitPromotionPlugin.ASOptionsData.mainGame) === null || _a === void 0 ? void 0 : _a.options);
            mainGameOptions.forEach((option) => {
                if (addedImages.indexOf(option.image) < 0) {
                    imgLoader.add(option.image, PromoPanelAssetConfig_1.PromoPanelAssetConfig.getGameResourcePathForActionSpins() + option.image);
                    addedImages.push(option.image);
                }
            });
            let bonusOptions = (0, ASInterfaces_1.parseOptionData)((_b = NolimitPromotionPlugin.ASOptionsData.bonusGame) === null || _b === void 0 ? void 0 : _b.options);
            bonusOptions.forEach((option) => {
                if (addedImages.indexOf(option.image) < 0) {
                    imgLoader.add(option.image, PromoPanelAssetConfig_1.PromoPanelAssetConfig.getGameResourcePathForActionSpins() + option.image);
                    addedImages.push(option.image);
                }
            });
        }
        return NolimitPromotionPlugin.apiPlugIn.getInitData().then(() => {
            var _a, _b;
            if (this.hasActionSpin()) {
                if (!((_b = (_a = NolimitPromotionPlugin.ASOptionsData) === null || _a === void 0 ? void 0 : _a.graphics) === null || _b === void 0 ? void 0 : _b.backgroundTextureName)) {
                    imgLoader.add("AS_REPLAY_BG", PromoPanelAssetConfig_1.PromoPanelAssetConfig.getGameResourcePathForActionSpins() + "REPLAY_BG" + PromoPanelConfig_1.PromoPanelConfig.JPG_FORMAT);
                }
                imgLoader.add("ActionSpinAnimation0", "/node_modules/@nolimitcity/promo-panel/resources/default/animation/Actionspin0.json");
            }
            if (this.hasNolimitVoucher() || this.hasActionSpin()) {
                imgLoader.add("AS_GAME_LOGO", PromoPanelAssetConfig_1.PromoPanelAssetConfig.getGameResourcePathForActionSpins() + "GAME_LOGO" + ".png");
            }
            return imgLoader.load();
        });
    }
    get isActionSpinRound() {
        const actionSpinsController = this._featureControllerMap.get(PromoPanelButtonIDs_1.PromoPanelButtonIDs.ACTION_SPINS);
        if (actionSpinsController) {
            return actionSpinsController.isActionSpinsRunning;
        }
        return false;
    }
    get isActionSpinPlayingBonusInGame() {
        const actionSpinsController = this._featureControllerMap.get(PromoPanelButtonIDs_1.PromoPanelButtonIDs.ACTION_SPINS);
        if (actionSpinsController) {
            return actionSpinsController.isPlayingBonusInGame;
        }
        return false;
    }
}
NolimitPromotionPlugin.IS_MINIMIZED = false;
exports.NolimitPromotionPlugin = NolimitPromotionPlugin;
//# sourceMappingURL=NolimitPromotionPlugin.js.map